import request from '@/utils/requestThingsBoard'

/** save User */
// TODO: Need ReFacotr
export function saveUser (params) {
  if (params.id) {
    return request({
      url: '/user',
      method: 'post',
      data: params
    })
  } else {
    return request({
      url: '/user?istarCreatePasswordUrl=' + encodeURIComponent('https://ems.istarscloud.com/createPassword'),
      method: 'post',
      data: params
    })
  }
}

export function getTenantAdmins (tenantId) {
  return request({
    url: '/tenant/' + tenantId + '/users?limit=9999999',
    method: 'get'
  })
}

export function getTenantAdminsAndSys (tenantId) {
  return request({
    url: '/tenant/adminAndsys/' + tenantId + '?limit=9999999',
    method: 'get'
  })
}

// TODO: Refactor
export function getTenantUsers (tenantId) {
  return request({
    url: '/tenant/users/' + tenantId + '?limit=9999999',
    method: 'get'
  })
}

export function deleteUser (userId) {
  return request({
    url: '/user/' + userId,
    method: 'delete'
  })
}

// 获取单个用户信息
export function getUser (userId) {
  return request({
    url: '/user/' + userId,
    method: 'get'
  })
}
